<template>
  <section class="calc-result" :class="'result--' + outcomeType">
    <transition name="fade">
      <div class="calc-loading" v-if="loading">
        <div class="calc-loading-anim-wrapper">
          <div class="calc-loading-anim calc-blueBg">
            <div class="calc-loading-logo"></div>
            <span class="calc-ripple calc-blueBg"></span>
            <span class="calc-ripple calc-blueBg"></span>
            <span class="calc-ripple calc-blueBg"></span>
          </div>
          <span class="calc-loading-anim-text">{{ resultLoadingLabel }}</span>
        </div>
      </div>
      <div v-else-if="!fileFormSubmitted && !emailFormSubmitted" class="inner">
        <restart-button v-if="outcomeType !== 'media'" class="restart-button" />
        <header class="header">
          <div class="header-inner">
            <div
              v-if="outcomeType == 'compare'"
              class="results-wrapper results-wrapper--compare"
            >
              <div class="total-price">
                <div class="total-price-wrapper">
                  <smart-image
                    class="header-icon"
                    :src="
                      compareTypeResults.length
                        ? 'images/result-icon.png'
                        : 'images/step-faint.png'
                    "
                    alt="Résultats"
                  />
                  <h2 class="header-title" v-html="resultTitle"></h2>
                  <span class="header-subtitle" v-html="resultSubtitle"></span>
                </div>
              </div>
            </div>
            <div class="results-wrapper" v-else-if="outcomeType == 'media'">
              <div class="all-results">
                <div class="all-results__title">
                  Votre audience potentielle<br />avec les critères suivants
                </div>
                <div class="media-all-results">
                  <div v-for="(step, i) in allResultsArray" :key="i">
                    <div>
                      <span
                        class="media-all-results__title"
                        v-if="
                          step.title &&
                            !(!Array.isArray(step.result) && !step.result.title)
                        "
                        v-html="step.title"
                      ></span>
                      <div v-if="step.result">
                        <span v-if="Array.isArray(step.result)">
                          <span
                            v-for="(result, i) in step.result"
                            :key="result.title"
                          >
                            {{ i > 0 ? " / " : "" }}{{ result.title }}
                          </span>
                        </span>
                        <span v-else-if="step.result.title">
                          {{ step.result.title }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="total-price">
                  <div class="total-price-ornament"></div>
                  <div class="total-price-ornament-2"></div>
                  <div class="total-price-wrapper">
                    <smart-image
                      class="header-stars"
                      src="images/result-stars.png"
                      alt="Votre audience"
                    />
                    <span class="total-price__price">{{
                      mediaAudienceResult
                    }}</span>
                    <div class="total-price__subtitle">personnes sur</div>
                    <div>
                      <smart-image
                        :src="`images/sim-medias/${allResultsEffect['a1']}.png`"
                        :alt="allResultsEffect['a1']"
                        class="media-social-network"
                      />
                    </div>
                  </div>
                </div>
                <div class="media-restart-wrapper">
                  <restart-button button class="media-restart" />
                </div>
              </div>
            </div>
            <div
              class="results-wrapper"
              v-else-if="outcomeType == 'calculation'"
            >
              <div class="all-results">
                <div
                  class="all-results__title"
                  v-if="additionalJsonData.resultTitle"
                  v-html="additionalJsonData.resultTitle"
                ></div>
                <div
                  class="all-results__subtitle"
                  v-if="additionalJsonData.resultSubtitle"
                  v-html="additionalJsonData.resultSubtitle"
                ></div>
              </div>
              <div class="total-price">
                <div class="total-price-wrapper">
                  <smart-image
                    class="header-stars"
                    src="images/result-stars.png"
                    alt="Votre prix"
                  />
                  <span class="total-price__price"
                    >{{ totalPrice }}&nbsp;<span class="f-main">€</span></span
                  >
                  <div class="total-price__subtitle">HT</div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div class="content">
          <div v-if="outcomeType == 'compare'">
            <div
              class="compare-result-card__row"
              v-if="compareTypeResults.length"
            >
              <div
                v-for="(result, i) in compareTypeResults"
                :key="i"
                class="compare-result-card__col"
              >
                <a
                  :href="
                    result.meta_box.efi_job_pdf
                      ? result.meta_box.efi_job_pdf[0].url
                      : ''
                  "
                  target="_blank"
                  class="compare-result-card__link"
                >
                  <div
                    class="compare-result-card"
                    v-html="result.title.rendered"
                  ></div>
                </a>
              </div>
            </div>
            <div v-else v-html="contentText" class="result-content-text"></div>
          </div>
          <div
            class="content__inner"
            v-if="resultLeftForm || resultRightForm || resultMediaForm"
          >
            <div class="form-methodoc-wrapper" v-if="resultLeftForm">
              <div class="form-methodoc">
                <div v-if="leftFormImage" class="form-methodoc-image-wrapper">
                  <smart-image
                    :src="leftFormImage"
                    alt="Méthodoc, créer un minisite"
                    width="123"
                  />
                </div>
                <div class="form-methodoc-content">
                  <p
                    class="form-intro"
                    v-html="
                      additionalJsonData.methodocText != null
                        ? additionalJsonData.methodocText
                        : `Recevez maintenant nos<br/><strong>8 plus belles infographies.</strong>`
                    "
                  ></p>
                  <p
                    class="form-intro form-intro--small"
                    v-if="additionalJsonData.resultLegalText"
                    v-html="additionalJsonData.resultLegalText"
                  ></p>
                </div>
                <div>
                  <form
                    @submit="submitFileForm"
                    action="https://hooks.zapier.com/hooks/catch/2293056/o449zr7/"
                    method="POST"
                    class="submit-file-form"
                  >
                    <input
                      type="email"
                      required
                      v-model="emailField"
                      placeholder="Votre email (envoi immédiat)*"
                      class="submit-file-form__input"
                    />
                    <button
                      :disabled="fileFormLoading"
                      type="submit"
                      class="calc-form-submit submit-file-form__submit"
                    >
                      OK
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div class="form-contact-wrapper" v-if="resultRightForm">
              <form
                @submit="submitEmailForm"
                action="https://hooks.zapier.com/hooks/catch/2293056/o4ztpcq/"
                method="POST"
                class="form-contact"
              >
                <p class="form-intro">
                  J'ai un projet, merci de me recontacter&nbsp;!
                </p>
                <div class="form-contact-fields-wrapper">
                  <div class="form-contact-fields">
                    <div>
                      <input
                        type="text"
                        required
                        v-model="nameField"
                        placeholder="Vos nom et prénom"
                      />
                    </div>
                    <div class="form-contact-row">
                      <div>
                        <input
                          type="email"
                          required
                          v-model="email2Field"
                          placeholder="Votre email"
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          v-model="companyNameField"
                          placeholder="Votre société"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      :disabled="emailFormLoading"
                      class="calc-form-submit"
                    >
                      OK
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="form-methodoc-wrapper" v-if="resultMediaForm">
              <div class="form-methodoc">
                <smart-image
                  src="images/sim-medias/form.png"
                  alt="Recevez maintenant nos 3 méthodologies Google / Facebook /
                    Display"
                  width="123"
                />
                <div class="form-methodoc-content">
                  <p class="form-intro">
                    Recevez gratuitement la méthodo pour avoir des campagnes
                    performantes en SEA, Display et Social
                  </p>
                  <p class="form-intro form-intro--small">
                    *Inscription conforme
                    <a href="https://www.eficiens.com/privacy/" target="_blank"
                      >RGPD Eficiens</a
                    >. Aucune exploitation de votre email.<br />Source des
                    simulations : outils de planification des supports - Juin
                    2020
                  </p>
                </div>
                <div>
                  <form
                    @submit="submitFileForm"
                    action="https://hooks.zapier.com/hooks/catch/2293056/owm14rf/"
                    method="POST"
                    class="submit-file-form"
                  >
                    <input
                      type="email"
                      required
                      v-model="emailField"
                      placeholder="Votre email (envoi immédiat)*"
                      class="submit-file-form__input"
                    />
                    <button
                      :disabled="fileFormLoading"
                      type="submit"
                      class="calc-form-submit submit-file-form__submit"
                    >
                      OK
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="inner">
        <header class="header">
          <div v-if="outcomeType == 'media'" class="header-inner">
            <div
              v-if="outcomeType == 'compare'"
              class="results-wrapper results-wrapper--compare"
            >
              <div class="total-price">
                <div class="total-price-wrapper">
                  <smart-image
                    class="header-icon"
                    :src="
                      compareTypeResults.length
                        ? 'images/result-icon.png'
                        : 'images/step-faint.png'
                    "
                    alt="Résultats"
                  />
                  <h2 class="header-title" v-html="resultTitle"></h2>
                  <span class="header-subtitle" v-html="resultSubtitle"></span>
                </div>
              </div>
            </div>
            <div class="results-wrapper" v-else-if="outcomeType == 'media'">
              <div class="all-results">
                <div class="all-results__title">
                  Votre audience potentielle<br />avec les critères suivants
                </div>
                <div class="media-all-results">
                  <div v-for="(step, i) in allResultsArray" :key="i">
                    <div>
                      <span
                        class="media-all-results__title"
                        v-if="
                          step.title &&
                            !(!Array.isArray(step.result) && !step.result.title)
                        "
                        v-html="step.title"
                      ></span>
                      <div v-if="step.result">
                        <span v-if="Array.isArray(step.result)">
                          <span
                            v-for="(result, i) in step.result"
                            :key="result.title"
                          >
                            {{ i > 0 ? " / " : "" }}{{ result.title }}
                          </span>
                        </span>
                        <span v-else-if="step.result.title">
                          {{ step.result.title }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="total-price">
                  <div class="total-price-ornament"></div>
                  <div class="total-price-ornament-2"></div>
                  <div class="total-price-wrapper">
                    <smart-image
                      class="header-stars"
                      src="images/result-stars.png"
                      alt="Votre audience"
                    />
                    <span class="total-price__price">{{
                      mediaAudienceResult
                    }}</span>
                    <div class="total-price__subtitle">personnes sur</div>
                    <div>
                      <smart-image
                        :src="`images/sim-medias/${allResultsEffect['a1']}.png`"
                        :alt="allResultsEffect['a1']"
                        class="media-social-network"
                      />
                    </div>
                  </div>
                </div>
                <div class="media-restart-wrapper">
                  <restart-button button class="media-restart" />
                </div>
              </div>
            </div>
            <div
              class="results-wrapper"
              v-else-if="outcomeType == 'calculation'"
            >
              <div class="all-results">
                <div
                  class="all-results__title"
                  v-if="additionalJsonData.resultTitle"
                  v-html="additionalJsonData.resultTitle"
                ></div>
                <div
                  class="all-results__subtitle"
                  v-if="additionalJsonData.resultSubtitle"
                  v-html="additionalJsonData.resultSubtitle"
                ></div>
              </div>
              <div class="total-price">
                <div class="total-price-wrapper">
                  <smart-image
                    class="header-stars"
                    src="images/result-stars.png"
                    alt="Votre prix"
                  />
                  <span class="total-price__price"
                    >{{ totalPrice }}&nbsp;<span class="f-main">€</span></span
                  >
                  <div class="total-price__subtitle">HT</div>
                </div>
              </div>
            </div>
          </div>
          <template v-else class="header-inner">
            <restart-button class="restart-button" />
            <smart-image
              class="header-icon"
              src="images/result-icon.png"
              retinaSrc="images/result-icon@2x.png"
              alt="Votre prix"
            />
            <h2 class="header-title">Votre prix<small>(HT)</small></h2>
            <span class="header-subtitle"
              >{{ totalPrice }}&nbsp;<span class="f-main">€</span></span
            >
          </template>
        </header>
        <div class="content">
          <div class="content__inner">
            <div class="calc-thanks">
              <div class="calc-thanks__inner">
                <h3 class="calc-thanks__title">Merci</h3>
                <p v-if="fileFormSubmitted">
                  Vous allez recevoir l’estimation et notre méthodologie dans
                  votre boîte mail.
                </p>
                <p v-if="emailFormSubmitted">
                  Un email vous a été envoyé.
                </p>
                <p>
                  Si vous souhaitez nous contacter : contact@eficiens.com
                </p>
                <p>
                  À bientôt !
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import RestartButton from "./ui/RestartButton.vue";
import SmartImage from "./ui/SmartImage.vue";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    RestartButton,
    SmartImage
  },
  data() {
    return {
      loading: true,
      fileFormLoading: false,
      fileFormSubmitted: false,
      emailFormLoading: false,
      emailFormSubmitted: false,
      emailField: "",
      email2Field: "",
      nameField: "",
      companyNameField: "",
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      mediaAudienceResult: 0
    };
  },
  computed: {
    outcomeType() {
      return this.$store.getters.outcomeType;
    },
    totalPrice() {
      return this.$store.getters.totalPrice
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    allResultsArray() {
      return this.$store.getters.allResultsArray;
    },
    AllResultArrayTitleItem() {
      return this.allResultsArray[0];
    },
    allResultsArrayWithoutTitleItem() {
      return this.allResultsArray.slice(1);
    },
    allResults() {
      return this.$store.getters.allResults;
    },
    allResultsEffect() {
      return this.$store.getters.allResultsEffect;
    },
    compareTypeResults() {
      return this.$store.getters.compareTypeResults;
    },
    resultLeftForm() {
      return this.$store.getters.resultLeftForm;
    },
    resultRightForm() {
      return this.$store.getters.resultRightForm;
    },
    resultMediaForm() {
      return this.$store.getters.resultMediaForm;
    },
    resultTitle() {
      if (this.outcomeType == "compare" && !this.compareTypeResults.length) {
        return this.$store.getters.noResultTitle;
      }
      return this.$store.getters.resultTitle;
    },
    contentText() {
      if (this.outcomeType == "compare" && !this.compareTypeResults.length) {
        return this.$store.getters.noResultContent;
      }
      return this.$store.getters.resultContent;
    },
    resultSubtitle() {
      if (this.outcomeType == "compare" && !this.compareTypeResults.length) {
        return this.$store.getters.noResultSubitle;
      }
      return this.$store.getters.resultSubtitle;
    },
    resultLoadingLabel() {
      return this.$store.getters.resultLoadingLabel;
    },
    leftFormImage() {
      return this.additionalJsonData.resultLeftFormImage;
    },
    additionalJsonData() {
      let additionalJsonData = {};
      let attributeValues = this.$store.getters.attributeValues(
        "additionalJsonData"
      );

      attributeValues.forEach(
        value => (additionalJsonData = { ...additionalJsonData, ...value })
      );

      return additionalJsonData;
    },
    banner() {
      return this.$store.getters.banner;
    }
  },
  beforeMount() {
    this.$store.dispatch("compareOutcomes");
  },
  methods: {
    navigateBack() {
      this.$store.dispatch("navigateBack");
    },
    async submitFileForm(e) {
      e.preventDefault();

      this.fileFormLoading = true;

      const copyResults = JSON.parse(JSON.stringify(this.allResults));

      Object.keys(copyResults).forEach(key => {
        if (typeof copyResults[key] === "string") {
          copyResults[key] = copyResults[key].replace(/\(|\)/g, "");
        }
      });

      const rawResponse = await fetch(e.target.action, {
        method: "POST",
        body: JSON.stringify({
          email: this.emailField,
          total:
            this.outcomeType === "media"
              ? this.mediaAudienceResult
              : this.totalPrice,
          ...copyResults,
          ...this.additionalJsonData
        })
      });

      this.$pushGTM({ action: "submit-form", label: "methodo-request-form" });

      const res = await rawResponse.json();

      this.fileFormLoading = false;

      if (res.status == "success") {
        this.fileFormSubmitted = true;
      }
    },
    async submitEmailForm(e) {
      e.preventDefault();

      this.emailFormLoading = true;

      const rawResponse = await fetch(e.target.action, {
        method: "POST",
        body: JSON.stringify({
          name: this.nameField,
          email: this.email2Field,
          company: this.companyNameField,
          total: this.totalPrice,
          ...this.allResults,
          ...this.additionalJsonData
        })
      });

      this.$pushGTM({ action: "submit-form", label: "recontact-request-form" });

      const res = await rawResponse.json();

      this.emailFormLoading = false;

      if (res.status == "success") {
        this.emailFormSubmitted = true;
      }
    }
  },
  async mounted() {
    if (this.outcomeType === "media") {
      let res = await fetch(this.$store.getters.dataJson);
      let data = await res.json();

      let mediaAudienceResult = 0;

      this.allResultsEffect["a2"].forEach(age => {
        this.allResultsEffect["a3"].forEach(geo => {
          mediaAudienceResult += parseInt(
            data["medias"][this.allResultsEffect["a1"]]["ages"][age]["geos"][
              geo
            ]
          );
        });
      });

      let percentage = parseFloat(
        data["medias"][this.allResultsEffect["a1"]]["interests"][
          this.allResultsEffect["a4"]
        ]
      );

      this.mediaAudienceResult = Math.round(mediaAudienceResult * percentage)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/**
* Results slider
*/

.swiper-container.calc-swiper {
  padding-bottom: 20px;

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    transform: scale(0.5);
    transition: all 0.3s $s-transition,
      transform 0.4s $s-transition-easing-inoutbounce;

    &:hover {
      background: $c-primary;
    }

    &:active,
    &:focus {
      outline: none;
    }
  }

  .swiper-wrapper {
    align-items: stretch;

    @include media(">=desktop") {
      transition: transform 600ms cubic-bezier(0.645, 0.045, 0.355, 1) !important;
    }
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination-bullet-active {
    background: $c-primary;
    transform: scale(1);
  }

  &.swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 0;
  }

  .swiper-button-prev,
  .swiper-button-next {
    top: 0;
    bottom: 0;
    height: auto;
    width: 40px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 16'%3E%3Cpath fill='%2321ACB8' fill-rule='nonzero' d='M7.5429 8.10355l-6.46968 6.46967c-.29289.2929-.29289.76777 0 1.06066.2929.2929.76777.2929 1.06066 0l6.64645-6.64644c.48816-.48816.48816-1.27962 0-1.76777L2.13388.57322c-.29289-.2929-.76776-.2929-1.06066 0-.29289.2929-.29289.76777 0 1.06066L7.5429 8.10355z'/%3E%3C/svg%3E");
    transition: transform 0.5s $s-transition-easing-bounce;

    @include media(">=desktop") {
      width: 50px;
    }

    &:hover {
      transform: scale(1.2);
    }

    &:active,
    &:focus {
      outline: none;
    }
  }

  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: -22px;

    @include media(">=desktop") {
      right: -50px;
    }
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: -22px;

    @include media(">=desktop") {
      left: -50px;
    }
    transform: scaleX(-1);

    &:hover {
      transform: scaleX(-1) scale(1.1);
    }
  }
}

.calc-result {
  position: relative;
  min-height: 400px;
  background: $c-background;
  border-radius: $s-border-radius;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 12px;
  box-shadow: $s-box-shadow-big;
}
</style>

<style lang="scss" scoped>
input {
  height: 47px;
  line-height: 47px;
  border-radius: 10px;
  border: 1px solid $c-input-border;
  padding: 0 15px;
}

.calc-form-submit {
  cursor: pointer;
  height: 47px;
  line-height: 47px;
  border-radius: 10px;
  background: $c-primary;
  color: $c-primary-contrast;
  border: none;
  padding: 0 27px;
  transition: all $s-transition;

  &:hover {
    background: darken($c-primary, 5%);
  }
}

.inner {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 490px;

  > * {
    flex: 1 1 auto;
  }
}

.content {
  border: 2px solid $c-gray-light;
  border-top: none;
  border-radius: 0 0 $s-border-radius $s-border-radius;
  display: flex;
  flex-direction: column;

  > * {
    flex: 1 1 auto;
  }

  .content__inner {
    @include media(">=desktop") {
      display: flex;
      align-items: stretch;
    }
  }
}

.header {
  position: relative;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 30px 30px;
  background: #77cad2;
  color: $c-white;
  border-radius: $s-border-radius $s-border-radius 0 0;

  .result--media & {
    background: #1799bf;
  }

  @include media(">=desktop") {
    padding: 15px 30px 45px 30px;
    min-height: 216px;

    .eficiensCalculatorApp--media & {
      padding-bottom: 15px;
    }
  }
}

.header-title {
  text-transform: uppercase;
  font-weight: bold;
  color: $c-primary;
  font-size: 25px;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;

  small {
    display: block;
    font-size: 0.5em;
  }

  @include media(">=desktop") {
    font-size: 38px;
  }
}

.header-subtitle {
  font-size: 60px;
  font-family: $f-title;
}

.header-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  text-align: center;
}

.header-icon,
.header-stars {
  display: block;
  position: relative;
  z-index: 10;
  width: 60%;
  height: auto;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 26px;

  @include media(">=desktop") {
    margin-top: -155px;
    width: 170px;
    margin-bottom: 0;
  }
}

.header-stars {
  margin-top: -60px;
  margin-bottom: 0;
  min-width: 160px;

  @include media(">=desktop") {
    margin-top: -98px;
    width: 304px;
  }
}

.results-wrapper {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  margin: -10px;

  > * {
    padding: 10px;
  }

  @include media(">=desktop") {
    align-items: flex-end;
    flex-direction: row;

    &--compare {
      justify-content: center;
    }
  }

  .total-price {
    @include media(">=desktop") {
      margin-top: 50px;

      .eficiensCalculatorApp--media & {
        margin-top: 0;
      }

      .header-icon {
        margin-bottom: 10px;
      }
    }
  }

  &--compare {
    .total-price-wrapper {
      background: none;
    }

    .header-subtitle {
      font-size: 30px;
    }
  }
}

.all-results {
  counter-reset: results;
  text-align: center;
  flex: 0 0 100%;
  max-width: 100%;

  @include media(">=desktop") {
    text-align: left;
    flex: 0 0 50%;
    max-width: 50%;
    margin-right: 40px;
    margin-top: 54px;
    margin-bottom: 20px;

    .result--media & {
      margin-top: 20px;
    }
  }

  &__result {
    padding: 10px;

    &--main {
      background: $c-background;
      border-radius: $s-border-radius;
      padding: 9px 15px;
      margin-bottom: 10px;

      .all-results__title {
        text-transform: uppercase;
        color: $c-primary;
        font-size: 24px;
      }

      .all-results__answer {
        font-size: 18px;
        opacity: 1;
      }
    }

    &:not(.all-results__result--main) {
      counter-increment: results;
      display: flex;
      &::before {
        content: counter(results);
        width: 23px;
        height: 23px;
        flex: 0 0 23px;
        background: $c-background;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        font-size: 16px;
        margin-right: 10px;
        padding-bottom: 2px;
      }
    }
  }

  &__title {
    display: block;
    font-family: $f-title-name;
    font-size: 32px;
    line-height: normal;

    @include media(">=desktop") {
      font-size: 38px;
    }
  }

  &__subtitle {
    font-family: $f-title-name;
    font-size: 18px;
    margin-top: 10px;

    @include media(">=desktop") {
      font-size: 24px;
    }
  }

  &__answer {
    opacity: 0.6;
    font-size: 12px;
  }
}

.all-results-arrows {
  width: 112px;
  background: url(~@/assets/images/result-arrows.svg) no-repeat center/contain;
  height: 231px;

  @include media("<desktop") {
    display: none;
  }
}

.total-price {
  order: -1;
  margin-top: 20px;
  font-family: $f-title-name;

  @include media(">=desktop") {
    margin-top: 230px;
    min-width: 270px;
    order: initial;
    display: flex;
    align-items: flex-end;

    &::before {
      content: "";
      display: block;
      position: relative;
      z-index: 1;
      width: 180px;
      height: 200px;
      background: url(~@/assets/images/result-man.png) no-repeat bottom
        center/contain;
      margin-right: -30px;
    }
  }

  &__price {
    font-size: 50px;

    @include media(">=desktop") {
      font-size: 75px;
    }
  }

  &__subtitle {
    font-size: 26px;
    font-weight: bold;

    @include media(">=desktop") {
      font-size: 40px;
    }
  }
}

.result--media {
  .total-price {
    position: relative;

    &__price {
      font-size: 60px;
    }

    &__subtitle {
      font-size: 32px;
    }
  }

  .total-price-ornament {
    &::before {
      content: "";
      position: absolute;
      z-index: 100;
      display: block;
      right: -20px;
      top: 50%;
      width: 36px;
      height: 36px;
      background: url(~@/assets/images/like.png) no-repeat bottom center/contain;
    }

    &::after {
      content: "";
      position: absolute;
      z-index: 100;
      display: block;
      width: 24px;
      height: 24px;
      top: -20px;
      right: -10px;
      background: url(~@/assets/images/favorite.png) no-repeat bottom
        center/contain;
    }
  }

  .total-price-ornament-2 {
    &::before {
      content: "";
      position: absolute;
      z-index: 100;
      display: block;
      left: 0;
      top: 50%;
      width: 24px;
      height: 24px;
      background: url(~@/assets/images/love.png) no-repeat bottom center/contain;
    }

    &::after {
      content: "";
      position: absolute;
      z-index: 100;
      display: block;
      width: 24px;
      height: 24px;
      top: 0;
      left: 0;
      background: url(~@/assets/images/love.png) no-repeat bottom center/contain;
    }
  }
}

.total-price-wrapper {
  text-align: center;
  background: $c-background;
  color: $c-text;
  padding: 20px;
  border-radius: $s-border-radius;
  box-shadow: 0 3px 0 #5dc1ca;

  @include media(">=desktop") {
    padding: 30px 20px 30px 20px;
  }
}

/**
* Compare Type Calculators (Jobs)
*/

.compare-result-card {
  @extend %box;

  padding: 22px;

  @include media(">=desktop") {
    padding: 35px 25px;
  }

  &__link {
    text-decoration: none;
    &:hover {
      .compare-result-card {
        @extend %box-hover;
      }
    }
  }

  &__row {
    @include flex-grid();
    padding: 30px;
    justify-content: center;
  }
}

/**
* FORMS
*/

.form-intro {
  font-family: $f-title;
  font-size: 20px;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: normal;

  @include media(">=desktop") {
    font-size: 30px;

    .eficiensCalculatorApp--media & {
      font-size: 22px;
    }
  }

  >>> a {
    color: inherit;
  }

  &--small {
    font-size: 14px;
    margin-bottom: 10px;

    .eficiensCalculatorApp--media & {
      font-size: 14px;
    }
  }
}

.form-methodoc-wrapper,
.form-contact-wrapper {
  padding: 20px;

  @include media(">=desktop") {
    flex: 1 0 50%;
    padding: 15px 25px;
  }
}

.form-methodoc-wrapper {
  background: #d4fae5;

  @include media(">=desktop") {
    background: #d4fae5 url(~@/assets/images/result-megaphone.png) no-repeat
      left center/130px;
    padding-left: 130px;
  }

  .result--media & {
    background-color: #cde9eb;
    background-image: none;
    padding-left: 25px;
  }
}

.form-methodoc-image-wrapper {
  flex: 0 0 auto;
}

.form-methodoc-content {
  padding: 0 10px;

  @include media(">=desktop") {
    padding: 0 20px;
  }
}

.form-methodoc {
  text-align: center;

  @include media("<desktop") {
    img {
      max-width: 30%;
      height: auto;
    }
  }

  @include media(">=desktop") {
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.submit-file-form {
  display: flex;

  &__input {
    width: 100%;
    flex: 1 1 auto;
    border-radius: 10px 0 0 10px;

    @include media(">=desktop") {
      min-width: 300px;

      .eficiensCalculatorApp--media & {
        min-width: 254px;
      }
    }
  }

  &__submit {
    border-radius: 0 10px 10px 0;
    font-weight: bold;
  }

  &__input,
  &__submit {
    height: 62px;
    line-height: 62px;
    font-size: 18px;
  }

  .eficiensCalculatorApp--media & {
    &__input {
      font-size: 15px;
    }
  }
}

.form-contact-wrapper {
  display: flex;
  align-items: center;
  background: $c-background-2;
}

.form-contact {
  width: 100%;
}

.form-contact-fields-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: -7px;

  > * {
    padding: 7px;
  }

  @include media(">=tablet") {
    flex-direction: row;
    align-items: flex-end;
  }
}

.form-contact-fields {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin: -7px;

  > * {
    padding: 7px;
  }

  input {
    width: 100%;
  }
}

.form-contact-row {
  display: flex;
  margin: -7px;

  > * {
    width: 100%;
    padding: 7px;
  }
}

.restart-button {
  position: relative;
  z-index: 1;

  @include media(">=desktop") {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.calc-thanks {
  text-align: center;
  width: 100%;
  background: $c-blue-light;
  font-family: $f-title;
  font-size: 26px;

  &__inner {
    max-width: 730px;
    margin: 0 auto;
    overflow: hidden;
  }

  &__title {
    font-size: 40px;
    text-align: center;
    margin-top: 0;
    margin-bottom: 20px;
  }
}

.media-restart-wrapper {
  text-align: center;
  margin-top: 20px;

  @include media(">=desktop") {
    padding-left: 145px;
  }
}

.media-restart {
  display: inline-block;
  margin-top: 10px;
}

.media-social-network {
  width: 65px;
  height: auto;
  margin-top: 15px;
}

.eficiensCalculatorApp--media {
  @include media(">=desktop") {
    .inner,
    .calc-loading {
      min-height: 676px;
    }

    .content {
      flex-grow: 0;
    }
  }
}
</style>

<style lang="scss">
.calc-blueBg {
  background-color: $c-primary !important;
  background-image: linear-gradient(90deg, $c-primary, $c-secondary);
}
.calc-loading {
  @include media(">=desktop") {
    min-height: 408px;
  }
}
.calc-loading-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 23px;
  height: 23px;
  opacity: 0.9;
  transform: translate(-50%, -50%);
  background: url(~@/assets/images/loading-logo.svg) no-repeat center/contain;

  .eficiensCalculatorApp--media & {
    width: 50px;
    height: 50px;
  }
}
.calc-loading-anim-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.calc-loading-anim {
  position: relative;
  height: 60px;
  width: 60px;
  text-align: center;
  border-radius: 100px;
  z-index: 1;

  .eficiensCalculatorApp--media & {
    width: 100px;
    height: 100px;
  }
}
.calc-loading-anim-text {
  font-family: $f-main;
  font-size: 22px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  margin-top: 40px;
  width: 260px;
  max-width: 80vw;

  .eficiensCalculatorApp--media & {
    font-size: 28px;
  }
}
.calc-loading-anim i {
  line-height: 56px;
  font-size: 30px;
}
.calc-loading-anim .calc-ripple {
  position: absolute;
  width: 160px;
  height: 160px;
  z-index: -1;
  left: 50%;
  top: 50%;
  opacity: 0;
  margin: -80px 0 0 -80px;
  border-radius: 100px;
  -webkit-animation: calc-ripple 1.8s infinite;
  animation: calc-ripple 1.8s infinite;
}

@-webkit-keyframes calc-ripple {
  0% {
    opacity: 1;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes calc-ripple {
  0% {
    opacity: 1;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.calc-loading-anim .calc-ripple:nth-child(2) {
  animation-delay: 0.3s;
  -webkit-animation-delay: 0.3s;
}
.calc-loading-anim .calc-ripple:nth-child(3) {
  animation-delay: 0.6s;
  -webkit-animation-delay: 0.6s;
}

.result-content-text {
  padding: 30px;
  text-align: center;

  a {
    color: $c-primary;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.media-all-results {
  line-height: 1.5;
  margin-top: 15px;
  font-size: 15px;
  font-family: "Raleway", sans-serif;
  font-weight: normal;

  &__title {
    font-size: 19px;
  }
}

.f-main {
  font-family: $f-main;
}
</style>
